import { Key, Plugs } from "@phosphor-icons/react";

import { Tag } from "common/components/ui/Tag";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";
import type { WorkspaceAccount } from "common/types";

interface LoginStatusTagProps {
  account: WorkspaceAccount;
  size: "sm" | "md";
}

export default function LoginStatusTag({ account, size }: LoginStatusTagProps) {
  const { state, type } = account;

  if (state === "LoggedIn") {
    return (
      <Tag
        variant="tertiary"
        leftIcon={<Key className="text-green-500" weight="fill" />}
        size={size}
      >
        Connected
      </Tag>
    );
  }

  if (state === "LoggedOut") {
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <Tag
            variant="disabled"
            leftIcon={<Plugs weight="fill" />}
            size={size}
          >
            Disconnected
          </Tag>
        </TooltipTrigger>
        <TooltipContent>
          {type === "rental"
            ? "Our team will automatically reconnect your Outreach Avatars every day. If the account stays disconnected for longer than expected, please contact us via Live Chat for immediate assistance"
            : "Disconnected accounts cannot execute campaign interactions. Reconnect this account at your earliest convenience"}
        </TooltipContent>
      </Tooltip>
    );
  }

  return (
    <Tag variant="tertiary" size={size}>
      Pending
    </Tag>
  );
}
